export default "__VITE_ASSET__DU5Mn92i__"